import { axiosInstance } from "./constant";

var baseURL = process.env.REACT_APP_API_URL;

async function AddNewJob(data) {
  try {
    const response = await axiosInstance.post(baseURL + `/jobs`, data);
    return response.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}
async function UpdateJobData(data, id) {
  try {
    const response = await axiosInstance.put(baseURL + `/jobs/${id}`, data);
    return response.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}
async function GetAllJobs() {
  try {
    const response = await axiosInstance.get(baseURL + `/jobs`);
    return response.data?.results;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}

async function GetJobDetails(id) {
  try {
    const response = await axiosInstance.get(baseURL + `/jobs/${id}`);
    return response.data?.results;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}
async function DeleteJob(id) {
  try {
    const response = await axiosInstance.delete(baseURL + `/jobs/${id}`);

    return response?.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}

async function GetAllApplicants(jobId) {
  try {
    const response = await axiosInstance.get(baseURL + `/applicant${jobId}`);
    return response.data?.results;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}
async function GetPreApplicants(lang) {
  try {
    const response = await axiosInstance.get(
      baseURL + `/preapplicant?lang=${lang}`
    );
    return response.data?.results;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}
async function GetCustomerSupport(lang) {
  try {
    const response = await axiosInstance.get(
      baseURL + `/customer/support?lang=${lang}`
    );
    return response.data?.results;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}
async function GetViolationsReports(lang) {
  try {
    const response = await axiosInstance.get(
      baseURL + `/reporting/violation?lang=${lang}`
    );
    return response.data?.results;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}
async function GetJobTitles() {
  try {
    const response = await axiosInstance.get(baseURL + `/jobs/job-titles`);
    return response.data?.results;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}
async function GetApplicantResume(id) {
  try {
    const response = await axiosInstance.get(
      baseURL + `/applicant/resume/${id}`
    );
    return response.data?.results;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}
async function GetPreApplicantResume(id) {
  try {
    const response = await axiosInstance.get(
      baseURL + `/preapplicant/resume/${id}`
    );
    return response.data?.results;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}
async function GetViolationReportFile(id) {
  try {
    const response = await axiosInstance.get(
      baseURL + `/reporting/violation/report/${id}`
    );
    return response.data?.results;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}
async function AddFinancialStatement(data, lang) {
  try {
    const response = await axiosInstance.post(
      baseURL + `/report?lang=${lang}`,
      data
    );
    return response.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}
async function GetAllReports() {
  try {
    const response = await axiosInstance.get(baseURL + `/report`);
    return response.data?.results;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}
async function GetReportById(id) {
  try {
    const response = await axiosInstance.get(baseURL + `/report/${id}`);
    return response.data?.results;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}

async function deleteReportStatement(id) {
  try {
    const response = await axiosInstance.delete(baseURL + `/report/${id}`);

    return response?.data;
  } catch (error) {
    const message = error.response
      ? error.response.data.message
      : "An error occurred";
    return message;
  }
}

export {
  GetViolationReportFile,
  GetAllJobs,
  GetJobDetails,
  DeleteJob,
  AddNewJob,
  GetAllApplicants,
  GetJobTitles,
  GetApplicantResume,
  GetCustomerSupport,
  GetViolationsReports,
  GetPreApplicantResume,
  GetPreApplicants,
  UpdateJobData,
  AddFinancialStatement,
  GetAllReports,
  GetReportById,
  deleteReportStatement,
};
